import CallHighlightActions from './CallHighlightActions';
import CallHighlightHeader from './CallHighlightHeader';
import { useFetchCallDetails } from './hooks/useFetchCallDetails';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallHighlight = ({
  gates = [],
  objectId
}) => {
  const {
    loading,
    error,
    data
  } = useFetchCallDetails(objectId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CallHighlightActions, {
      objectId: objectId
    }), /*#__PURE__*/_jsx(CallHighlightHeader, {
      data: data,
      error: error,
      loading: loading,
      gates: gates
    })]
  });
};
export default CallHighlight;